export function Logo({ className = "h-12" }: { className?: string }) {
  return (
    <img 
      src="/logo.png" 
      alt="خدمات الإلكترونية العائلة"
      className={className}
    />
  );
}